import { render, staticRenderFns } from "./AlbumDescription.vue?vue&type=template&id=4086460c&"
import script from "./AlbumDescription.vue?vue&type=script&lang=js&"
export * from "./AlbumDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports